






import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ViewLogModal extends Vue {
  // Props

  @Prop({ required: true })
  public log!: any;

  @Prop({ required: true })
  public title!: string;

  @Prop({ default: undefined })
  public deep!: number;
}
